<ng-container *ngIf="age > -1">
    <ng-container *ngIf="age === 0">< 1 an</ng-container>
  <ng-container *ngIf="age === 1">1 an</ng-container>
  <ng-container *ngIf="age > 1">{{age}} ans</ng-container>
</ng-container>
